import { extractErrorMessage } from '@zealy/utils';
import { apiV2 } from '../services';
export const isFeatureFlagEnabled = async (flagKey, subdomain) => {
    const res = await apiV2.featureFlagV2.isEnabled({
        params: { flagKey, subdomain },
    });
    if (res.status === 200) {
        return res.body.enabled;
    }
    throw new Error(`isFeatureFlagEnabled fail: status=${res.status}, message=${extractErrorMessage(res.body)}`);
};
